export default __webpack_public_path__ + "9e7150bd890136556c44f4e6c815daad.svg";